import axios from 'axios';
import { Config } from '../utils/Config';
import { identityAuth } from '../auth/IdentityAuth';

// Authenticated client for the /KioskAdmin/* endpoints. Unlike kioskRequest (public
// /Kiosk/* endpoints, no auth), these are [WelbeeAuthorize] + scope-guarded on the
// PeopleManagement API, so the caller's Welbee identity bearer token must be sent.
const kioskAdminClient = axios.create({
  responseType: 'json',
  baseURL: Config.PPL_MNGMT_BASE_URL,
  transformResponse: (response) => response,
});

kioskAdminClient.defaults.headers.post['Content-Type'] = 'application/json';
kioskAdminClient.defaults.headers.post.Accept = 'application/json';
kioskAdminClient.defaults.headers.pragma = 'no-cache';
kioskAdminClient.defaults.withCredentials = false;
kioskAdminClient.defaults.timeout = 240000;

const getAuthHeader = () => {
  const token = identityAuth.getToken() || localStorage.getItem('token');
  return token ? `Bearer ${token}` : null;
};

const kioskAdminRequest = (options) => {
  const authHeader = getAuthHeader();
  const headers = { ...(options.headers || {}) };
  if (authHeader) {
    headers.Authorization = authHeader;
  }

  return kioskAdminClient({ ...options, headers })
    .then((response) => {
      if (typeof response.data === 'string') {
        try {
          return JSON.parse(response.data);
        } catch {
          return response.data;
        }
      }
      return response.data;
    })
    .catch((error) => {
      let data = { message: error.message, success: false };
      if (error.response) {
        const raw = error.response.data;
        if (typeof raw === 'string') {
          // Server may return a non-JSON / empty string — don't let JSON.parse mask the error.
          try {
            data = JSON.parse(raw);
          } catch {
            data = { message: raw || error.message, success: false };
          }
        } else {
          data = raw;
        }
      }
      return Promise.reject(data);
    });
};

export default kioskAdminRequest;
